import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.css'],
})
export class InputComponent {
  @Input() sufix: string = '';
  @Input() inputType: 'number' | 'text' = 'text';
  @Input() maxDigits: number = 0;
  @Input() placeholder: string = '';
  @Input() acceptMinus: boolean = false;

  @Input()
  get controlForm(): FormControl {
    return this._controlForm;
  }
  set controlForm(controlForm: FormControl) {
    this._controlForm = controlForm;
  }
  private _controlForm: FormControl = new FormControl();

  constructor() { }

  get textLength() {
    const { value } = this._controlForm;
    if (typeof value !== 'undefined' && value !== null) {
      return value.toString().length;
    }
    return 0;
  }

  onKeyDown(event: any): void {
    const { value } = event.target;
    if (typeof value !== 'undefined' && value !== null) {
      const numbersAndLettersRegexp = /[^\w]/gi;
      const underscoreRegexp = new RegExp('_', 'gi');
      const minusRegexp = new RegExp('-', 'gi');
      let cleaned = value;

      if (numbersAndLettersRegexp.test(value)) {
        cleaned = cleaned.replace(numbersAndLettersRegexp, '');
      }
      if (underscoreRegexp.test(value)) {
        cleaned = cleaned.replace(underscoreRegexp, '');
      }

      if (minusRegexp.test(value) && !this.acceptMinus) {
        cleaned = cleaned.replace(minusRegexp, '');
      }
      if (cleaned !== value) {
        // eslint-disable-next-line no-param-reassign
        event.target.value = cleaned;
        this._controlForm.patchValue(cleaned);
      }
    }
  }

}
